import TypeBennesController from './type.bennes.controller';

export default {
    template: require('./type.bennes.tpl.html'),
    controller: TypeBennesController
};
